<script>
  import { BASE_DATA_URL } from '../constants';
  import { buildCacheParam } from '../utils';
  import * as d3 from 'd3';
  import irelandMapChart from '../charts/irelandMapChart';
  import { onMount } from 'svelte';
  import DataUpdated from './DataUpdated.svelte';

  const timeParse = d3.timeParse("%Y-%m-%d");

  let mapData;
  let data;
  let cityLeaIds;
  let chartContainer;
  $: dataUpdated = data && timeParse(data[0].eventDate);

  onMount(async () => {
    const cacheParam = buildCacheParam();
    [mapData, data, cityLeaIds] = await Promise.all([
            d3.json(`${BASE_DATA_URL}/ireland.topojson`),
            d3.csv(`${BASE_DATA_URL}/ireland.csv?d=${cacheParam}`),
            d3.json(`${BASE_DATA_URL}/city-lea-ids.json?d=${cacheParam}`)
    ]);
    const chart = irelandMapChart()
            .mapData(mapData)
            .data(data)
            .cityLeaIds(cityLeaIds);
    d3.select(chartContainer).call(chart);
  });
</script>

<div class="chart-outer">
  <h2>Where are the most cases?</h2>
  <p class="description">Cases per 100k</p>
  <p class="tip">Click on a city to show a city map. Click outside it to hide it.</p>
  <div bind:this={chartContainer}/>
  <!--<DataUpdated date={dataUpdated}/>-->
</div>
